"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorRange = void 0;
var ColorRange = /** @class */ (function () {
    function ColorRange() {
    }
    Object.defineProperty(ColorRange, "Moisture", {
        get: function () {
            return this.BlueToYellow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorRange, "Revenue", {
        get: function () {
            return this.MonoGreen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorRange, "Cost", {
        get: function () {
            return this.MonoRed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorRange, "FieldVariability", {
        get: function () {
            return this.MonoBlue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorRange, "InSeasonChange", {
        get: function () {
            return this.RedToYellow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorRange, "ScoutPriority", {
        get: function () {
            return this.BlueToRedBright;
        },
        enumerable: false,
        configurable: true
    });
    /** Red - yellow - green */
    ColorRange.Stoplight = [
        "#C2100D",
        "#ED652E",
        "#FF9200",
        "#FFDB01",
        "#DBED01",
        "#92C900",
        "#49A400",
    ];
    ColorRange.RedToBlue = [
        "#990800",
        "#b81911",
        "#d73027",
        "#e05851",
        "#eb847f",
        "#f5b4b0",
        "#ffeceb",
        "#ffffff",
        "#e6f1ff",
        "#b5cceb",
        "#8badd9",
        "#6590c7",
        "#4575b4",
        "#295ea3",
        "#114991",
    ];
    ColorRange.BlueToRedBright = [
        "rgb(92,169,233)",
        "rgb(97,170,233)",
        "rgb(101,172,234)",
        "rgb(106,173,234)",
        "rgb(110,174,234)",
        "rgb(115,176,235)",
        "rgb(119,177,235)",
        "rgb(124,178,235)",
        "rgb(128,180,236)",
        "rgb(133,181,236)",
        "rgb(137,182,236)",
        "rgb(142,183,236)",
        "rgb(146,185,237)",
        "rgb(151,186,237)",
        "rgb(155,187,237)",
        "rgb(160,189,238)",
        "rgb(229,204,129)",
        "rgb(231,203,125)",
        "rgb(232,201,121)",
        "rgb(234,200,117)",
        "rgb(236,199,113)",
        "rgb(237,197,109)",
        "rgb(239,196,105)",
        "rgb(240,195,101)",
        "rgb(242,193,97)",
        "rgb(244,192,93)",
        "rgb(245,191,89)",
        "rgb(247,190,85)",
        "rgb(249,188,81)",
        "rgb(250,187,77)",
        "rgb(252,186,73)",
        "rgb(253,184,69)",
        "rgb(252,153,74)",
        "rgb(252,149,75)",
        "rgb(252,146,77)",
        "rgb(253,142,78)",
        "rgb(253,138,79)",
        "rgb(253,134,80)",
        "rgb(253,131,82)",
        "rgb(253,127,83)",
        "rgb(254,123,84)",
        "rgb(254,120,85)",
        "rgb(254,116,87)",
        "rgb(254,112,88)",
        "rgb(254,109,89)",
        "rgb(254,105,90)",
        "rgb(255,101,92)",
        "rgb(255,97,93)",
    ];
    ColorRange.GreenToIndigo = [
        "#1b9e77",
        "#ffffff",
        "#565199",
    ];
    ColorRange.BlueToYellow = [
        "#453781",
        "#52a275",
        "#f5e428",
    ];
    ColorRange.MonoGreen = [
        "#479707",
        "#5DA821",
        "#73B834",
        "#89CA46",
        "#9FDC58",
        "#B4ED69",
        "#CAFF7A",
    ];
    ColorRange.MonoOrange = [
        "#733200",
        "#B34D00",
        "#D95F02",
        "#E38034",
        "#EDA36B",
        "#F5C7A4",
        "#FFEFE3",
    ];
    ColorRange.MonoRed = [
        "#AB0A1D",
        "#C43531",
        "#D2524C",
        "#E06D68",
        "#EC8785",
        "#F6A1A3",
        "#FFBAC2",
    ];
    ColorRange.MonoIndigo = [
        "#262266",
        "#3c3780",
        "#565199",
        "#7570b3",
        "#9a97cc",
        "#c1bee6",
        "#eeedff",
    ];
    ColorRange.Soil = [
        "#E86832",
        "#E89B32",
        "#D53353",
        "#AA512B",
        "#EC6FB7",
        "#7F5488",
        "#B4A678",
        "#E83294",
        "#715135",
    ];
    ColorRange.Planting = [
        "#920DD3",
        "#F78080",
        "#47BCD3",
        "#FFC046",
        "#981135",
    ];
    ColorRange.Hybrid = [
        "#197CCE",
        "#74BB32",
        "#2DD0C6",
        "#4A90E2",
        "#96BEDE",
        "#265B86",
        "#37AF3E",
        "#9A9126",
        "#E7E10E",
    ];
    ColorRange.MonoBlue = [
        "#194B88",
        "#72C4FF",
    ];
    ColorRange.RedToYellow = [
        "#E64900",
        "#FFD34F",
    ];
    return ColorRange;
}());
exports.ColorRange = ColorRange;
